var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { RadioButton } from 'primereact/radiobutton';
var RadiobuttonControl = /** @class */ (function (_super) {
    __extends(RadiobuttonControl, _super);
    function RadiobuttonControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (target, value) { return function () {
            if (value !== _this.value) {
                _this.handleChange(value);
                var type = target.actionButton;
                if (type) {
                    _this.props.onEvent({ type: type, target: target });
                }
            }
        }; };
        return _this;
    }
    RadiobuttonControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, supportedValues = def.supportedValues;
        var hint = frontOptions.hint, style = frontOptions.style, className = frontOptions.className, label = frontOptions.label, supportedValuesOptions = frontOptions.supportedValues;
        var items = supportedValuesOptions || supportedValues || [];
        var printLabel = label || def.label;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(frontOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement("div", { key: def.id, id: def.id, className: 'p-dir-col' + className ? " " + className : '', "field-code": def.code, title: hint }, items.filter(function (it) { return !it.hidden; }).map(function (it, idx) {
                return React.createElement("div", { key: it.value, className: 'p-col', style: { display: 'flex' } },
                    React.createElement(RadioButton, { ref: function (ref) {
                            if (ref) {
                                ref['element'].setAttribute('field-code', def.code + "-" + idx);
                            }
                        }, style: style, value: it.value, onChange: _this.onChange(def, it.value), name: def.id, disabled: def.disabled || def.readonly || it.disabled, checked: _this.value === it.value, inputId: def.id + "-" + idx }),
                    React.createElement("label", { htmlFor: def.id + "-" + idx, className: 'p-radiobutton-label' }, it.label));
            })),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    return RadiobuttonControl;
}(FormBaseElement));
export { RadiobuttonControl };
//# sourceMappingURL=Radiobutton.js.map